import { Grid, Group, Layout, Page } from "@/comn/components";
import {
    APIS,
    PGEUIDS,
    SF_MENU_SRCH,
    SG_MENU_LIST,
    SG_SCRN_LIST,
} from "@/tz/go/egaz/osci/ptl/ptl/menu/services/OsciAuthMenuService";
import { useFetch, useForm, useGrid, useModal, usePage, useResource, useStore, useToast } from "@/comn/hooks";
import { useEffect } from "react";

/*
 * Menu and Screen List Popup
 * !== 메뉴 및 화면 목록 팝업 ==!
 */
export const OSCI0104013Q = (props: any) => {
    const { callback, authMenuList, authId, ptlTpCd, bsopClsfCd } = props;

    const { pgeUid } = usePage({ pgeUid: PGEUIDS.osci0104013q });
    const modal = useModal();
    const toast = useToast();
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid });

    useResource({
        defaultSchema: [
            { area: "comnCd", comnCd: "OSC0088" },
            { area: "comnCd", comnCd: "OSC0095" },
        ],
    });

    const form = {
        menuSrch: useForm({
            defaultSchema: SF_MENU_SRCH,
            defaultValues: pgeStore?.form || {},
        }),
    };

    const grid = {
        menuList: useGrid({ defaultSchema: SG_MENU_LIST }),
        scrnList: useGrid({ defaultSchema: SG_SCRN_LIST }),
    };

    const fetch = {
        getMenuList: useFetch({
            api: () => APIS.getMenuList(form.menuSrch.getValues()),
            onSuccess: (data: any) => {
                data.menuList.content.forEach((item: any, index: number) => {
                    if (authMenuList.findIndex((subItem: any) => item.menuId === subItem.menuId) > -1) {
                        item = { ...item, authId: authId };
                        data.menuList.content = data.menuList.content.with(index, item);
                    }
                });

                grid.menuList.setData(data.menuList);
                setStore(pgeUid, { form: form.menuSrch.getValues() });
            },
            onError: () => toast.showToast({ type: "error", content: "msg.osc.00043" }), // Failed to select. !== 조회가 실패하였습니다. ==!
        }),
        getScrnList: useFetch({
            api: (data: any) => APIS.getScrnList(data),
            onError: () => toast.showToast({ type: "error", content: "msg.osc.00043" }), // Failed to select. !== 조회가 실패하였습니다. ==!
        }),
    };

    const handler = {
        onSrchBtnClick: form.menuSrch.handleSubmit(
            () => {
                grid.menuList.setPage(0);
                fetch.getMenuList.fetch();
            },
            () => {
                modal.openModal({ content: "msg.osc.00003" }); // Data is invalid, !== 데이터가 유효하지않습니다. ==!
            },
        ),
        onApplyBtnClick: () => {
            if (!grid.menuList.isChecked()) {
                modal.openModal({ content: "msg.osc.00197" }); // 등록대상을 선택하세요.
                return;
            }
            callback(grid.menuList.getChecked());
        },

        onMenuGridCellClick: (cell: any) => {
            fetch.getScrnList.fetch(cell.rowValues);
        },
        onClear: () => {
            form.menuSrch.clearValues();
            form.menuSrch.setValue("bsopClsfCd", bsopClsfCd);
            form.menuSrch.setValue("ptlTpCd", ptlTpCd);
        },
    };

    const render = { menuList: { checkbox: (rowValues: any) => rowValues.authId != authId } };

    useEffect(() => {
        form.menuSrch.setEditable("ptlTpCd", false);
        form.menuSrch.setEditable("bsopClsfCd", false);

        form.menuSrch.setValue("bsopClsfCd", bsopClsfCd);
        form.menuSrch.setValue("ptlTpCd", ptlTpCd);
    }, []);

    return (
        <Page pgeUid={pgeUid} info={true}>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.menuSrch.schema.bsopClsfCd} />
                            <Group.Control {...form.menuSrch.schema.ptlTpCd} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.menuSrch.schema.menuId} />
                            <Group.Control {...form.menuSrch.schema.menuNm} />
                        </Group.Row>
                    </Group.Section>

                    <Layout>
                        <Layout.Left>
                            <Layout.Button role={"reset"} onClick={handler.onClear} />
                        </Layout.Left>
                        <Layout.Right>
                            <Layout.Button role={"search"} onClick={handler.onSrchBtnClick} />
                        </Layout.Right>
                    </Layout>
                </Group.Body>
            </Group>

            <Layout direction={"row"}>
                <Group>
                    <Group.Body>
                        <Group.Section>
                            <Grid
                                {...grid.menuList.grid}
                                render={render.menuList}
                                onCellClick={handler.onMenuGridCellClick}
                            />
                        </Group.Section>
                    </Group.Body>
                </Group>

                <Group>
                    <Group.Body>
                        <Group.Section>
                            {" "}
                            <Grid {...grid.scrnList.grid} data={fetch.getScrnList.data?.scrnList} />{" "}
                        </Group.Section>
                    </Group.Body>
                </Group>
            </Layout>

            <Layout>
                <Layout.Right>
                    <Layout.Button role={"apply"} onClick={handler.onApplyBtnClick} />
                </Layout.Right>
            </Layout>
        </Page>
    );
};
